var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongTerm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.6 17.3v11.5c0 .7-.5 1.2-1.2 1.2H10.7c-.7 0-1.2-.5-1.2-1.2V17.3M26.3 19.9h3.1M29.4 23.4h-3.1M29.4 26.9h-3.1M11.7 19.9h3.1M14.8 23.4h-3.1M14.8 26.9h-3.1M16.6 19.9h3.1M19.7 23.4h-3.1M19.7 26.9h-3.1M21.5 19.9h3.1M24.6 23.4h-3.1M24.6 26.9h-3.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.4 12c.7 0 1.2.5 1.2 1.2v4.2H9.5v-4.2c0-.7.5-1.2 1.2-1.2zM25.2 14.1V10M16.2 14.1V10"
}))));
export default SvgLongTerm;